import { render } from "./OrderDetailModal.vue?vue&type=template&id=55c0d748&scoped=true"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js"

import "./OrderDetailModal.vue?vue&type=style&index=0&id=55c0d748&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c0d748"]])

export default __exports__